import LevelManagementSection from "../components/level-management-section";

export default function LevelManagementPage() {
  return (
    <div className="h-full flex flex-col gap-6">
      <div className="h-full">
        <LevelManagementSection />
      </div>
    </div>
  );
}
